export const instructionsContentStyle = {
    fontSize: "medium"
}